// Formatters + day labels for a coupon's time-rule fields, shared by the system
// and organization coupon detail pages. Encodings mirror CouponForm
// (bit 0 = Monday; minutes since local midnight).

export const DAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const minutesToHHMM = (minutes?: number | null): string => {
  if (minutes == null) return '';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};

/** valid_time_start/end (minutes since midnight) → "HH:MM – HH:MM", or "Any time". */
export const formatTimeRange = (start?: number | null, end?: number | null): string => {
  if (start == null && end == null) return 'Any time';
  return `${minutesToHHMM(start)} – ${minutesToHHMM(end)}`;
};

const formatDate = (value: string, withYear: boolean): string => {
  // Parse as local midnight so a YYYY-MM-DD value never shifts a day by timezone.
  const date = new Date(`${value.slice(0, 10)}T00:00:00`);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    ...(withYear ? { year: 'numeric' } : {}),
  });
};

/**
 * valid_from / valid_until (ISO date strings) → "Jul 1 – Jul 31, 2026",
 * "From Jul 1, 2026", "Until Jul 31, 2026", or "No date limit".
 */
export const formatDateRange = (from?: string | null, until?: string | null): string => {
  if (!from && !until) return 'No date limit';
  if (from && until) {
    const sameYear = from.slice(0, 4) === until.slice(0, 4);
    return `${formatDate(from, !sameYear)} – ${formatDate(until, true)}`;
  }
  if (from) return `From ${formatDate(from, true)}`;
  return `Until ${formatDate(until as string, true)}`;
};
